import { NgModule } from '@angular/core';
import { CurrencyPipe } from './currency/currency';
import { QuantityPipe } from './quantity/quantity';
import { AddressPipe } from './address/address';
import { AddressTypePipe } from './address-type/address-type';
import { MethodPipe } from './method/method';
import { StyleSanitizerPipe } from './../pipes/style-sanitizer/style-sanitizer';
@NgModule({
	declarations: [CurrencyPipe,
    QuantityPipe,
    QuantityPipe,
    AddressPipe,
    AddressTypePipe,
    MethodPipe,
    StyleSanitizerPipe],
	imports: [],
	exports: [CurrencyPipe,
    QuantityPipe,
    QuantityPipe,
    AddressPipe,
    AddressTypePipe,
    MethodPipe,
    StyleSanitizerPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts